import { MoreOutlined } from "@ant-design/icons";
import { ReactNode, CSSProperties } from "react";
import {  Content, ContentCardWrapper, Title,  TitleCn} from "./ContentCard.styled";

interface ContentCardProps {
    titleCn: string,
    titleEn: string,
    style?: CSSProperties,
    children?: ReactNode[] | ReactNode,
    onTitleClick?: () => void,
}

let ContentCard: React.FC<ContentCardProps> = (props)=> {

    return <ContentCardWrapper style={props.style}>
       
        <Title>
            <TitleCn onClick={props.onTitleClick}>{props.titleCn}</TitleCn>
            {/* <TitleSeparator> / </TitleSeparator> */}
            {/*<TitleEn>{props.titleEn}</TitleEn>*/}
        </Title>

        <Content>
            {props.children}
        </Content>
    </ContentCardWrapper>
};

export default ContentCard;

